import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { FastField as FormikField } from 'formik';
import { Select, Option } from '@xo-union/tk-component-fields';
import USStates from './us-state';
import Countries from './countries';

export enum DropdownType {
  country = 'country',
  state = 'state',
}

interface DropdownProps {
  type: DropdownType;
}

const fieldProps = {
  country: {
    name: 'address.country',
    label: 'Country',
  },
  state: {
    name: 'address.state',
    label: 'State',
  },
};

const CountriesOptions = (): ReactElement[] => Countries.map(({ name }) => <Option key={name} value={name} />);

const USStatesOptions = (): ReactElement[] => USStates.map(({ abbreviation: a }) => <Option key={a} value={a} />);

const Dropdown: React.FC<DropdownProps> = ({ type }) => {
  const renderOptions = React.useCallback(
    (): ReactElement[] => (type === DropdownType.country ? CountriesOptions() : USStatesOptions()),
    [type]
  );

  const { name, label } = fieldProps[type];
  // NOTE: country needs to be sent as an abbreviation
  return (
    <FormikField name={name}>
      {({ field, form }: any): ReactElement => (
        <Select {...field} label={label} onChange={(e: any): void => form.setFieldValue(field.name, e.option.value)}>
          {renderOptions()}
        </Select>
      )}
    </FormikField>
  );
};

Dropdown.propTypes = {
  type: PropTypes.oneOf([DropdownType.country, DropdownType.state]).isRequired,
};

export default Dropdown;
